import { render, staticRenderFns } from "./clientCategoriesComponent.vue?vue&type=template&id=0766a941&scoped=true"
import script from "./clientCategoriesComponent.vue?vue&type=script&lang=js"
export * from "./clientCategoriesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0766a941",
  null
  
)

export default component.exports